// @flow

import { RECEIVED_FOOTER_SETTINGS } from './constants';
import type { FooterSettings } from '../../types';

export type ReceivedFooterSettings = {|
  type: typeof RECEIVED_FOOTER_SETTINGS,
  payload: FooterSettings,
|};

export const receivedFooterSettings = (data: FooterSettings): ReceivedFooterSettings => ({
  type: RECEIVED_FOOTER_SETTINGS,
  payload: data,
});

export default null;
